module.exports = __webpack_public_path__ + "static/media/close-black.3d6c7a66.svg";